import type { ReactNode } from 'react';
import { AuthSplit } from '@/shared/ui/auth-split';

/**
 * The production console's signed-out screen.
 *
 * The shape lives in `shared/ui/auth-split.tsx`; this supplies the three
 * strings that differ per portal. The retention sentence is deliberate and is
 * the design's own wording - somebody about to trigger a rollout should read
 * that their name is on it before they sign in, not after.
 */
export function AuthLayout({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: ReactNode;
}) {
  return (
    <AuthSplit
      tag="PRODUCTION"
      headline="Fleet health, crash triage and staged rollouts."
      blurb="Production role required. Every action in this portal is attributed and retained for 400 days."
      domain="www.ops.nudent.ai"
      title={title}
      {...(description ? { subtitle: description } : {})}
    >
      {children}
    </AuthSplit>
  );
}
